var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactModal',{attrs:{"data-test-id":"UpgradeModal__baseModal","showModal":_vm.showModal,"title":"Request an Upgrade"},on:{"close":_vm.handleClose,"onCall":_vm.handleOutreachLinkClicked,"onEmail":_vm.handleEmailButtonClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }